import React from "react";
// import CV from '../../Assets/Documents/CV.pdf';
import {Link} from 'react-scroll'


export default class CallToAction extends React.Component {
    render() {
        return (
            <div className="cta">
                <a href={'https://docs.google.com/document/d/1I5_bQWlazTXOgvsCgoNNuePVhNSY69qiGQuXy7CQNTs/edit?usp=sharing'} download className="btn" target='_blank' rel="noreferrer"> Read CV</a>
                <Link to="#contact" spy={true} smooth={true} offset={50} duration={500}  isDynamic={true} className="btn btn-primary">
                Let's Chat
				</Link>
            </div>
        );
    }
}